import { render, staticRenderFns } from "./TOUTransactionHistory.vue?vue&type=template&id=1ec7b1ea&"
import script from "./TOUTransactionHistory.vue?vue&type=script&lang=ts&"
export * from "./TOUTransactionHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports